import { useLocation } from 'react-router-dom';

import { StripeCustomerBillingInfo } from '@/types/schema';

export function useStripeRedirectUrl(
  props: {
    billingInfo: Partial<StripeCustomerBillingInfo> | null;
    targetTier?: string;
  } & (
    | {
        isBusiness: true;
        taxIdType?: string;
        taxId?: string;

        businessName?: string;
        invoiceEmail?: string;
      }
    | { isBusiness: false }
  )
) {
  const location = useLocation();
  const currentPath = location.pathname;
  const { billingInfo, isBusiness, targetTier } = props;

  let businessInfo = '';
  if (isBusiness) {
    const { taxIdType, taxId, businessName, invoiceEmail } = props;

    const taxIdStr =
      taxIdType && taxId
        ? `&tax_id=${encodeURIComponent(taxId)}&tax_id_type=${taxIdType}`
        : '';
    const businessNameStr = businessName
      ? `&business_name=${encodeURIComponent(businessName)}`
      : '';
    const invoiceEmailStr = invoiceEmail
      ? `&invoice_email=${encodeURIComponent(invoiceEmail)}`
      : '';
    businessInfo = `${taxIdStr}${businessNameStr}${invoiceEmailStr}&is_business=true`;
  }

  return (
    window.location.origin +
    currentPath +
    '/setup-success' +
    `?billinginfo=${encodeURIComponent(JSON.stringify(billingInfo))}` +
    `&target_tier=${encodeURIComponent(targetTier || 'undefined')}` +
    businessInfo
  );
}
